module.exports = __webpack_public_path__ + "media/images/icon-mask-apple-ba545694b0b5c9415bc4c084d9cc311d.png";